<!-- Header -->
<div mat-dialog-title translate>Report Options - {{reportName}}</div>

<!-- Content -->

<mat-dialog-content>
    <div *ngIf="!isFromMenu" style = "padding-bottom: 5px;">
        <i>Please ensure you have selected any parameter values you want to save or hide prior to coming to this page.</i>
        <br />
        <i>
            <span style="font-weight: bold;"> 
                It is strongly recommeneded you click the "How To" below to understand the behavior.
            </span>
        </i>
    </div>

    <div>
<!-- disabled="isFromMenu" -->
        <mat-radio-group (change)="IsDistrictReportDefinitionsChanged($event)">
            <mat-radio-button style="font-weight: bold;" value="false" checked>Personal</mat-radio-button>
            <mat-radio-button [disabled]="isFromMenu" style="font-weight: bold;" *ngIf="userHasDistrictPermissions" value="true"
                [matTooltip] ="isFromMenu ? 'District Report Options can only be set once a report is open' : ''">District
            </mat-radio-button>
        </mat-radio-group>
    </div>

    <table class="table" style="width:100%;">
        <tr>
            <!-- <th style="padding-left:5px; width:15px;">
                        <tyl-checkbox 
                            [(checked)]="snapshotCheckAll"
                            (change)="snapshotCheckAllClick($event)"
                            id="snapshotCheckAll_ID"
                            name="snapshotCheckAll">
                        </tyl-checkbox>
                    </th> -->
            <th style="width:400px">Parameter</th>
            <th style="width:100px">
                <tyl-checkbox [(checked)]="saveAllChecked" (change)="saveAllChanged($event)" id="saveAllChecked_ID"
                    name="saveAllChecked">
                </tyl-checkbox>
                Save
            </th>
            <th style="width:100px">
                <tyl-checkbox [(checked)]="hideAllChecked" (change)="hideAllChanged($event)" id="hideAllChecked_ID"
                    name="hideAllChecked">
                </tyl-checkbox>
                Hide
            </th>
            <!-- <th style="width:200px">Allow User Save</th>
                    <th style="width:200px">Allow User Hide</th> -->
            <th style="width:100px; color:gray;">Is User</th>
            <th style="width:100px; color:gray;">Is District</th>
            <th *ngIf="inDebugMode" style="width:100px; color:gray;">Is System</th>
        </tr>

        <!-- [style.background-color]="reportDef.SetBackgroundColorForSavedDefinition == true ? getBackgroundColorForSavedDefinition(reportDef) : null" -->
        <tr style="line-height:25px; border: 1px solid silver;" *ngFor="let reportDef of reportDefinitions; let i = index"
            [style.background-color]="reportDef.BackgroundColorForSavedDefinition">
            <!-- <td style="width:400px; padding-left: 5px;" [style.color]="isDisabled(reportDef) == true ? silver : null"><i *ngIf="isDisabled(reportDef)">{{reportDef.ParameterLabel}}</i *ngIf="isDisabled(reportDef)"></td> -->
            <td style="width:400px; padding-left: 5px;"><span [style.font-style]="isDisabled(reportDef) ? 'italic' : null">{{reportDef.ParameterLabel}}</span></td>

            <td style="width:100px">
                <mat-checkbox  [(ngModel)]="reportDef.SaveChecked" (ngModelChange)="saveChecked(reportDef)"
                    id="canSave_ID + {{i}}" id="canSave + {{i}}" [disabled]="isSaveDisabled(reportDef)">
                </mat-checkbox>
            </td>

            <td style="width:100px">
                <mat-checkbox [(ngModel)]="reportDef.HideChecked" (ngModelChange)="hideChecked(reportDef)"
                    id="isHidden_ID + {{i}}" id="isHidden + {{i}}" [disabled]="isDisabled(reportDef)">
                </mat-checkbox>
            </td>
            <!-- 
                    <td style="width:200px">
                            <mat-checkbox 
                                [(value)]="reportDef.AllowUserSaveParameter" 
                                [(ngModel)]="reportDef.AllowUserSaveParameter"
                                id="AllowUserSaveParameter_ID + {{i}}"
                                id="AllowUserSaveParameter + {{i}}"
                                [disabled] = "!userHasDistrictPermissions"
                            >
                        </mat-checkbox>
                    </td>

                    <td style="width:200px">
                            <mat-checkbox 
                                [(value)]="reportDef.AllowUserHideParameter" 
                                [(ngModel)]="reportDef.AllowUserHideParameter"
                                id="AllowUserHideParameter_ID + {{i}}"
                                id="AllowUserHideParameter + {{i}}"
                                [disabled] = "!userHasDistrictPermissions"
                            >
                        </mat-checkbox>
                    </td> -->

            <td style="width:100px">
                <mat-checkbox [(ngModel)]="reportDef.IsUserDefinedParameter"
                    id="isUserDefinedParameter_ID + {{i}}" id="isUserDefinedParameter + {{i}}" [disabled]="true">
                </mat-checkbox>
            </td>

            <td style="width:100px">
                <mat-checkbox [(ngModel)]="reportDef.IsDistrictDefinedParameter"
                    id="isDistrictDefinedParameter_ID + {{i}}" id="isDistrictDefinedParameter + {{i}}" [disabled]="true">
                </mat-checkbox>
            </td>

            <td *ngIf="inDebugMode" style="width:100px">
                <mat-checkbox [(ngModel)]="reportDef.IsSystem" id="isSystem_ID + {{i}}"
                    id="isSystem + {{i}}" [disabled]="true">
                </mat-checkbox>
            </td>

            <!-- <td style="width:100px">{{reportDef.CanSave}}</td> -->
            <!-- <td style="width:100px">{{reportDef.IsHidden}}</td> -->
            <!-- <td style="width:100px">{{reportDef.IsDistrictDefinedParameter}}</td> -->
            <!-- <td style="width:100px">{{reportDef.IsSystem}}</td> -->

        </tr>
    </table>

</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions>
    <div class="flex-footer">
        <div class="flex-footer-left">
            <tyl-button style="float:left; color: black;" image="Legend.png" label="Legend" (clickEvent)="legendClick()"></tyl-button>
            <tyl-button style="float:left; color: black;" image="help black.png" label="How To" (clickEvent)="howToClick()"></tyl-button>
            

        </div>

        <div class="flex-footer-right">
            <div class="flex-footer-right">
                <tyl-button *ngIf="this.inDebugMode" style="float:right; color: black;" image="next arrow.png" label="Selected Report To Console"
                    (clickEvent)="selectedReportToConsole()"></tyl-button>
                <tyl-button *ngIf="this.inDebugMode" style="float:right; color: black;" image="next arrow.png" label="Definitions To Console"
                    (clickEvent)="defintionsToConsole()"></tyl-button>
                <tyl-button style="float:right; color: black;" image="cancel.png" translate label="Close"
                    (clickEvent)="closeClick()"></tyl-button>
                <tyl-button style="float:right; color: black;" image="post.png" translate label="Save" (clickEvent)="saveReportOptionsClick()"></tyl-button>
            </div>
        </div>
    </div>
</mat-dialog-actions>